module.exports = "/assets/6eed581cb701538ae5e872fb6e8d0ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P7.png
// module id = 1706
// module chunks = 0